export const headerNavItems = [
  { label: '首页', href: '#hero' },
  { label: '热点专题', href: '#carousel' },
  { label: '热门视频', href: '#media' },
  { label: '吃瓜排行', href: '#ranking' },
  { label: '平台特色', href: '#features' },
];

export const heroData = {
  tag: '🔥 今日最热爆料',
  h1: '91吃瓜爆料 — 全网最热娱乐八卦第一站',
  slogan: '高清免费 · 每日更新 · 吃瓜不停',
  description: '91吃瓜爆料网专注娱乐八卦与热门事件深度追踪，覆盖明星动态、网红绯闻、综艺内幕、影视资讯等全网热点。我们以最快的速度、最全的角度，为吃瓜群众提供高清视频在线播放与实时爆料内容。无论是热搜话题还是圈内秘闻，这里都是你第一时间掌握真相的首选平台。每日海量更新，随时随地，想看就看。',
  stats: [
    { label: '每日更新', value: '200+条' },
    { label: '高清视频', value: '10000+部' },
    { label: '吃瓜群众', value: '500万+' },
  ],
  primaryCta: { label: '立即吃瓜', href: '#carousel' },
  secondaryCta: { label: '下载APP', href: '#app' },
};

export const appData = {
  title: '91吃瓜 APP — 掌上吃瓜更便捷',
  description: '随时随地，一手爆料尽在掌握。支持 iOS 与 Android，高清播放、离线缓存、推送提醒，不错过任何热门大瓜。',
  features: ['极速播放', '离线缓存', '实时推送', '夜间模式'],
  badge: '新版本 v3.8.0 已上线',
};

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20casual%20style%20simple%20portrait%20neutral%20expression%20clean%20background%20modern%20minimal&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '3分钟前',
    content: '这个瓜我吃了三天了，越吃越上头！91的更新速度真的快，别的平台还在猜，这边已经实锤了。',
    likes: 1289,
    tag: '热评',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20avatar%20fashionable%20casual%20simple%20portrait%20light%20background%20modern&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '八卦小能手',
    time: '15分钟前',
    content: '刚从微博过来，那边的料还没这边全。91吃瓜的视频清晰度是真的高，码率碾压其他站。',
    likes: 867,
    tag: '精华',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20guy%20avatar%20trendy%20streetwear%20simple%20portrait%20clean%20minimal%20warm%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '理性吃瓜人',
    time: '28分钟前',
    content: '作为一个追了十年娱乐新闻的老粉，91的料源确实可靠，不像某些营销号乱编。推荐给所有爱吃瓜的朋友。',
    likes: 542,
    tag: '精选',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20avatar%20natural%20look%20simple%20portrait%20soft%20lighting%20minimal%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '深夜吃瓜群众',
    time: '42分钟前',
    content: '每晚睡前必刷91，已经成了习惯。界面干净没广告弹窗，体验比其他同类站好太多了。',
    likes: 321,
    tag: '热评',
  },
];

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20scene%20with%20microphones%20and%20cameras%20dramatic%20lighting%20warm%20red%20ambient%20glow%20modern%20broadcast%20atmosphere%20editorial%20photography%20high%20contrast%20with%20deep%20shadows%20artistic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '独家爆料',
    title: '顶流艺人疑似恋情曝光，深夜同返公寓画面流出',
    summary: '据知情人士透露，该艺人近期频繁现身某高档小区，与神秘女子同行画面被拍。事件持续发酵中…',
    heat: '987万',
    time: '2小时前',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20stage%20with%20colorful%20lights%20and%20audience%20dramatic%20performance%20atmosphere%20entertainment%20production%20warm%20vibrant%20colors%20high%20energy%20editorial%20photography&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '综艺内幕',
    title: '综艺节目录制现场突发冲突，导师选手互怼引热议',
    summary: '知名选秀节目最新一期录制中，某导师与选手发生激烈争执，现场一度中断。节目组尚未回应。',
    heat: '756万',
    time: '5小时前',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20cameras%20and%20crew%20members%20dramatic%20lighting%20cinematic%20atmosphere%20movie%20production%20warm%20ambient%20professional%20editorial%20photography&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '影视追踪',
    title: '年度大制作电影片场曝光，主演阵容超豪华引期待',
    summary: '投资超5亿的国产科幻巨制今日开放媒体探班，主演阵容包含多位一线明星，特效场景首次公开。',
    heat: '654万',
    time: '8小时前',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20trending%20topic%20visualization%20with%20glowing%20notification%20icons%20and%20hashtags%20digital%20atmosphere%20warm%20red%20and%20amber%20tones%20modern%20tech%20aesthetic%20editorial%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '热搜解析',
    title: '某女星深夜发文后又秒删，内容引人遐想',
    summary: '该女星凌晨发布一段意味深长的文字后迅速删除，粉丝截图已在各大平台疯传。业内猜测不断。',
    heat: '521万',
    time: '12小时前',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Music%20awards%20ceremony%20red%20carpet%20with%20spotlights%20and%20glamorous%20atmosphere%20celebrities%20arriving%20photographers%20flashing%20cameras%20elegant%20evening%20event%20warm%20luxury%20editorial%20photography&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '颁奖盛典',
    title: '音乐盛典获奖名单提前泄露？主办方紧急回应',
    summary: '网传某音乐颁奖礼完整获奖名单流出，多位提名者名次与预期大相径庭。官方声明称名单不实。',
    heat: '438万',
    time: '1天前',
  },
];

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20gossip%20news%20collage%20with%20smartphone%20screen%20showing%20social%20media%20feed%20warm%20ambient%20lighting%20magazine%20style%20flatlay%20editorial%20photography%20clean%20background&width=600&height=400&seq=card-01&orientation=landscape',
    title: '某男团成员被曝与经纪人恋爱三年',
    category: '明星八卦',
    excerpt: '据圈内人士透露，该男团成员与女经纪人已经秘密交往超过三年，团队内部人尽皆知但对外严格保密。',
    time: '3小时前',
    views: '234万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20film%20festival%20event%20with%20movie%20posters%20and%20red%20carpet%20elegant%20cinema%20atmosphere%20warm%20golden%20lighting%20premium%20editorial%20photography&width=600&height=400&seq=card-02&orientation=landscape',
    title: '某导演新片选角内幕大揭秘',
    category: '影视资讯',
    excerpt: '多位当红演员竞争同一角色，最终人选出乎所有人意料。知情人士称导演看重的是演技而非流量。',
    time: '6小时前',
    views: '187万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Fashion%20magazine%20cover%20photoshoot%20behind%20the%20scenes%20with%20studio%20lights%20and%20styling%20team%20glamorous%20atmosphere%20warm%20editorial%20photography&width=600&height=400&seq=card-03&orientation=landscape',
    title: '时尚杂志封面人物争议，P图过度引发吐槽',
    category: '时尚娱乐',
    excerpt: '某女星最新杂志封面被指P图严重失真，网友纷纷晒出对比图。该杂志尚未对此事作出回应。',
    time: '9小时前',
    views: '156万',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20ring%20light%20and%20microphone%20modern%20influencer%20setup%20warm%20cozy%20atmosphere%20content%20creator%20workspace%20editorial%20photography&width=600&height=400&seq=card-04&orientation=landscape',
    title: '知名主播直播间翻车事件全记录',
    category: '网红动态',
    excerpt: '某头部主播在直播中不慎说漏嘴，爆出行业惊人内幕，随后紧急下播。完整事件时间线整理。',
    time: '12小时前',
    views: '132万',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20colorful%20light%20show%20and%20enthusiastic%20crowd%20music%20performance%20energetic%20vibe%20warm%20atmospheric%20lighting%20editorial%20photography&width=600&height=400&seq=card-05&orientation=landscape',
    title: '演唱会假唱风波再起，粉丝晒出现场证据',
    category: '音乐圈',
    excerpt: '某歌手近期演唱会被质疑对口型，粉丝整理多段现场录音与官方音源对比，差异明显引发热议。',
    time: '1天前',
    views: '98万',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=TV%20drama%20filming%20location%20outdoor%20set%20with%20crew%20and%20equipment%20cinematic%20sunset%20lighting%20professional%20production%20scene%20warm%20atmosphere%20editorial%20photography&width=600&height=400&seq=card-06&orientation=landscape',
    title: '热播剧编剧被扒抄袭，原著作者发声维权',
    category: '影视资讯',
    excerpt: '豆瓣高分热播剧被指多处情节与某网络小说高度相似，原作者已委托律师收集证据准备起诉。',
    time: '1天前',
    views: '87万',
  },
];

export const topicsData = [
  { id: 1, name: '#某女星离婚内幕', heat: '2.3亿阅读', hot: true },
  { id: 2, name: '#综艺录制冲突', heat: '1.8亿阅读', hot: true },
  { id: 3, name: '#男团恋情曝光', heat: '1.5亿阅读', hot: true },
  { id: 4, name: '#电影选角争议', heat: '1.2亿阅读', hot: false },
  { id: 5, name: '#假唱风波', heat: '9800万阅读', hot: true },
  { id: 6, name: '#编剧抄袭门', heat: '8600万阅读', hot: false },
  { id: 7, name: '#片场路透', heat: '7200万阅读', hot: false },
  { id: 8, name: '#代言翻车', heat: '6500万阅读', hot: false },
  { id: 9, name: '#颁奖名单泄露', heat: '5100万阅读', hot: false },
];

export const mediaData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20entertainment%20news%20with%20dramatic%20lighting%20microphone%20and%20breaking%20news%20graphics%20warm%20red%20accents%20modern%20broadcast%20design%20professional%20look&width=640&height=360&seq=media-01&orientation=landscape',
    title: '独家：某顶流艺人私下真实状态曝光',
    duration: '05:23',
    views: '567万',
    tag: '独家',
    time: '2小时前',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Investigative%20reporting%20style%20video%20frame%20with%20documents%20and%20magnifying%20glass%20warm%20dramatic%20lighting%20journalism%20atmosphere%20professional%20editorial%20look&width=640&height=360&seq=media-02&orientation=landscape',
    title: '深扒：某综艺节目背后的资本局',
    duration: '08:47',
    views: '423万',
    tag: '深度',
    time: '5小时前',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20interview%20style%20video%20thumbnail%20with%20two%20chairs%20and%20studio%20lighting%20dramatic%20atmosphere%20talk%20show%20set%20warm%20professional%20look&width=640&height=360&seq=media-03&orientation=landscape',
    title: '圈内人亲述：那些年我们吃过的假瓜',
    duration: '12:15',
    views: '389万',
    tag: '访谈',
    time: '8小时前',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Timeline%20style%20visualization%20of%20events%20with%20dates%20and%20icons%20entertainment%20news%20recap%20dramatic%20warm%20lighting%20editorial%20design%20professional&width=640&height=360&seq=media-04&orientation=landscape',
    title: '2024年度十大娱乐事件完整回顾',
    duration: '15:30',
    views: '312万',
    tag: '盘点',
    time: '1天前',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Comparison%20style%20video%20thumbnail%20split%20screen%20with%20before%20and%20after%20entertainment%20news%20fact%20check%20dramatic%20warm%20lighting%20editorial%20professional&width=640&height=360&seq=media-05&orientation=landscape',
    title: '真相解密：某热搜事件前后完整对比',
    duration: '06:52',
    views: '278万',
    tag: '辟谣',
    time: '1天前',
  },
];

export const indexData = [
  { id: 1, title: '明星八卦专区', count: '1256篇', icon: 'ri-star-line', desc: '最新明星动态与绯闻追踪' },
  { id: 2, title: '综艺内幕揭秘', count: '892篇', icon: 'ri-tv-line', desc: '综艺节目幕后真实故事' },
  { id: 3, title: '影视深度解析', count: '756篇', icon: 'ri-film-line', desc: '电影电视剧全方位解读' },
  { id: 4, title: '音乐圈风云', count: '634篇', icon: 'ri-music-line', desc: '音乐行业最新资讯与八卦' },
  { id: 5, title: '网红动态追踪', count: '589篇', icon: 'ri-live-line', desc: '网红主播圈的热门事件' },
  { id: 6, title: '时尚潮流前线', count: '478篇', icon: 'ri-shirt-line', desc: '时尚圈与明星穿搭解析' },
  { id: 7, title: '每日热搜合辑', count: '每日更新', icon: 'ri-fire-line', desc: '全网热搜话题一网打尽' },
];

export const aboutData = {
  title: '关于91吃瓜爆料',
  content: '91吃瓜爆料网成立于2020年，是国内领先的娱乐资讯聚合平台。我们拥有一支专业的编辑团队和遍布全国的信息网络，致力于为吃瓜群众提供最快、最全、最真实的娱乐八卦内容。平台涵盖明星动态、综艺内幕、影视资讯、音乐圈风云、网红追踪等多个板块，日均更新内容超过200条，累计服务超过500万吃瓜用户。我们坚持"真实、快速、全面"的原则，让每一位用户都能在这里吃到最新鲜的瓜。',
  highlights: [
    { icon: 'ri-team-line', label: '专业编辑团队', desc: '50+资深娱记' },
    { icon: 'ri-flashlight-line', label: '极速更新', desc: '日均200+条' },
    { icon: 'ri-user-heart-line', label: '真实可靠', desc: '多方交叉验证' },
    { icon: 'ri-smartphone-line', label: '多端覆盖', desc: 'Web/App全支持' },
  ],
};

export const contactData = {
  title: '联系我们 / 投稿爆料',
  description: '如果你有独家爆料线索或娱乐新闻素材，欢迎通过以下方式与我们联系。我们承诺对所有爆料人信息严格保密，优质爆料稿件一经采用将给予丰厚报酬。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@91chigua.com' },
    { icon: 'ri-wechat-line', label: '微信客服', value: '91chigua666' },
    { icon: 'ri-phone-line', label: '合作热线', value: '400-888-9191' },
  ],
  disclaimer: '注：本站所有内容均来自公开渠道整理，仅供参考娱乐。如涉及侵权请联系删除。',
};

export const rankingData = [
  { id: 1, rank: 1, title: '某女星离婚内幕持续发酵，前夫再发声', heat: '2.3亿', trend: 'up', change: '+3' },
  { id: 2, rank: 2, title: '综艺录制现场冲突完整视频曝光', heat: '1.8亿', trend: 'up', change: '+5' },
  { id: 3, rank: 3, title: '男团成员与经纪人恋情细节流出', heat: '1.5亿', trend: 'up', change: '+1' },
  { id: 4, rank: 4, title: '电影选角内幕：多位顶流争角失败', heat: '1.2亿', trend: 'down', change: '-2' },
  { id: 5, rank: 5, title: '演唱会假唱风波技术分析视频走红', heat: '9800万', trend: 'up', change: '+8' },
  { id: 6, rank: 6, title: '热播剧编剧抄袭疑云新证据出现', heat: '8600万', trend: 'up', change: '+4' },
];

export const updatesData = [
  { id: 1, time: '刚刚', content: '某男星被拍到深夜出入某高档会所，同行的还有多名圈内人士', tag: '最新' },
  { id: 2, time: '10分钟前', content: '热门综艺节目官宣新一季导师阵容，两位顶流确认加盟', tag: '综艺' },
  { id: 3, time: '25分钟前', content: '某女星发文辟谣整容传闻，晒出童年照片力证天然', tag: '辟谣' },
  { id: 4, time: '40分钟前', content: '知名编剧新作开拍，主演阵容含金量十足引期待', tag: '影视' },
  { id: 5, time: '1小时前', content: '音乐节演出阵容公布，多组国际大牌确认参加', tag: '音乐' },
  { id: 6, time: '1.5小时前', content: '某网红直播带货翻车，产品涉假已被平台下架', tag: '网红' },
  { id: 7, time: '2小时前', content: '古装剧路透照流出，主演造型引发网友热议', tag: '路透' },
  { id: 8, time: '3小时前', content: '颁奖典礼红毯环节争议服饰登上热搜', tag: '时尚' },
  { id: 9, time: '4小时前', content: '某老牌歌手宣布复出演唱会计划，门票预售火爆', tag: '音乐' },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '7x24小时全天候监测，热点事件最快5分钟内上线。专业编辑团队实时追踪，确保你永远走在吃瓜第一线。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '所有爆料内容均经过多方交叉验证，坚决杜绝假瓜谣言。我们与多家权威娱乐媒体建立合作，信息源真实可信。',
  },
  {
    id: 3,
    icon: 'ri-hd-line',
    title: '高清体验',
    desc: '全站视频支持1080P高清播放，自适应带宽智能切换。无广告纯净体验，沉浸式吃瓜不受干扰。',
  },
];

export const faqData = [
  {
    id: 1,
    q: '91吃瓜爆料的内容来源可靠吗？',
    a: '我们的内容来自专业编辑团队的信息采集和多方交叉验证。核心爆料均标注信息来源，同时与多家娱乐媒体保持合作，确保内容的真实性和可信度。对于未经证实的传闻，我们会明确标注"待核实"。',
  },
  {
    id: 2,
    q: '91吃瓜爆料网的视频需要付费吗？',
    a: '所有视频内容完全免费观看，无需任何付费。我们提供高清流畅的播放体验，支持手机和电脑端随时访问。未来如果推出增值服务会提前公告，但基础内容始终保持免费。',
  },
  {
    id: 3,
    q: '如何向91吃瓜爆料投稿或提供线索？',
    a: '你可以通过页面底部的联系方式向我们投稿。发送邮件至 tips@91chigua.com，或添加微信客服 91chigua666。我们承诺对所有爆料人信息严格保密，优质稿件一经采用给予报酬。',
  },
  {
    id: 4,
    q: '91吃瓜有手机APP可以下载吗？',
    a: '有的！91吃瓜APP已上架各大应用商店，支持 iOS 和 Android 系统。APP 提供高清播放、离线缓存、实时推送等功能，比网页端体验更好。页面顶部有下载入口可以直接跳转。',
  },
];

export const footerData = {
  description: '91吃瓜爆料网 — 国内领先的娱乐资讯聚合平台。提供91吃瓜在线观看、91吃瓜视频在线观看、91吃瓜在线播放等高清免费内容，每日更新热门吃瓜视频，服务超过500万吃瓜群众。',
  links: [
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
    { label: '吃瓜排行', href: '#ranking' },
    { label: '常见问答', href: '#faq' },
    { label: '用户协议', href: '#' },
    { label: '隐私政策', href: '#' },
  ],
  copyright: '© 2024 91吃瓜爆料网 All Rights Reserved.',
};